var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixeledArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.739258 0L2.68663 0V2.06349H4.79189L4.79189 4.02116H6.79189L6.79189 2.06349L8.89715 2.06349V0L10.7393 0L10.7393 5.87302L8.68663 5.87302V7.8836H6.79189L6.79189 10L4.79189 10L4.79189 7.8836L2.89715 7.8836L2.89715 5.87302H0.739258L0.739258 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixeledArrowDown);
export default __webpack_public_path__ + "static/media/pixeled-arrow-down.f7c67ca0c275bab956ddc5b7252cc042.svg";
export { ForwardRef as ReactComponent };